import { Icon } from "@captions-web/icons";
import { createFileRoute } from "@tanstack/react-router";
import { t } from "i18next";

import { EmptyPageState } from "~/components/empty-page-state";
import { LayoutSimple } from "~/components/layouts/simple";
import { Button } from "~/components/primitives/button";
import { CreateAudioBox } from "~/modules/project/components/create-audio-box";
import { css } from "~/styled-system/css";

export const Route = createFileRoute("/_app/home")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LayoutSimple
      width="wide"
      title={
        <span
          className={css({
            color: "$gray.500",
          })}
        >
          {t("mirage-studio:project-detail.title-fallback")}
        </span>
      }
      actions={
        <Button
          variant="secondary"
          size="md"
          icon={<Icon name="options" />}
          iconPosition="only"
          className={css({ visibility: "hidden" })}
        />
      }
      floatingContent={<CreateAudioBox />}
    >
      <EmptyPageState
        title={t("mirage-studio:new-project.empty-state.title")}
        iconName="film-strip-shine"
      />
    </LayoutSimple>
  );
}
